











































import { Component, Mixins, Prop } from "vue-property-decorator";
import OptionListBoxSelector from "../../system/selectors/OptionListBoxSelector.vue";
import { WorkflowPhaseEditorModel, WorkflowRouteEditorModel } from "../../../domain/workflow/editor";
import { SelectorDialogMixin } from "../../../components/system";
import { StandardOption } from "../../system/selectors/mixins";
import Enumerable from "linq";
import { ReceptionDateTranslator } from "../../../domain/workflow";
import { DateFormatter } from "../../../domain/system";


@Component({
  components: {
    OptionListBoxSelector,
  },
})
export default class RoutePatternSelectorDialog extends Mixins(SelectorDialogMixin) {
  @Prop()
  workflowRoutes: WorkflowRouteEditorModel[];

  @Prop()
  baseDate: Date;

  _dateTranslator: ReceptionDateTranslator;

  created(): void {
    this._dateTranslator = new ReceptionDateTranslator();
  }

  get options(): StandardOption<WorkflowRouteEditorModel>[] {
    if (!this.workflowRoutes) { return []; }

    return Enumerable.from(this.workflowRoutes)
      .select(r => new StandardOption<WorkflowRouteEditorModel>(r.name, r))
      .toArray();
  }

  get selectedRoutePhases(): WorkflowPhaseEditorModel[] {
    return this.selected != null
      ? this.selected.phases
      : [];
  }

  async selectOption(): Promise<WorkflowRouteEditorModel> {
    const result = await this.show<WorkflowRouteEditorModel>(null);
    if (!result) { return null; }
    const cloned = result.clone();
    cloned.phases.forEach(p => {
      if (p.isEnable && p.limitDays !== null) {
        p.limitDate = this.calculateLimitDate(p.limitDays);
      }
    });
    return cloned;
  }

  areRoutesEqual(source: WorkflowRouteEditorModel, destination: WorkflowRouteEditorModel): boolean {
    return (source === destination)
      || (source && destination && source.id === destination.id);
  }

  getLimitDaysText(phase: WorkflowPhaseEditorModel): string {
    if (phase == null || !phase.isEnable || phase.limitDays === null) { return ""; }
    return phase.limitDays + "日後";
  }

  getLimitDateText(phase: WorkflowPhaseEditorModel): string {
    if (phase == null || !phase.isEnable || phase.limitDays === null) { return ""; }
    const result = this.calculateLimitDate(phase.limitDays);
    return DateFormatter.format(result, "YYYY/MM/DD");
  }

  calculateLimitDate(limitDays: number): Date {
    return this._dateTranslator.addDays(
      this.baseDate,
      limitDays
    );
  }
}
